import { Option } from "@typedefs/modulesInterfaces";
import { apiSlice } from "../../apiSlice";

interface AppParameter {
	id: number;
	name: string;
	value: number;
	unit: string;
}

interface IsConfigCorrectPayload {
	climate: number;
	moisture: number;
	soilType: number;
}

interface SoilOrganicCarbonsResponse {
	climate: number;
	moisture: number;
	soil_type: number;
	data_url: string;
	value: number | null;
	id: number;
}

interface CultivationDaysDefaultPayload {
	region: number;
}

interface CropYieldDefaultPayload {
	landUseType: number;
	region: number;
}

interface CropYieldStatsResponse extends Option {
	continent: number;
	land_use_type: number;
	average: number;
}
interface CultivationDaysDefaultResponse extends Option {
	continent: number;
	cultivation_period: number;
}

interface CountryEmissionFactorsResponse {
	id: number;
	data_url: string;
	operating_margin: number;
	combined_margin: number;
	country: number;
}

interface Assessment {
	id: number;
	name: string;
	link: string
}

interface AssessmentByYear {
	year: number;
	assessments: Assessment[];
}

export interface CountryAssessments {
	name: string;
	iso_code: string;
	years: AssessmentByYear[];
}

export interface HIHAssessmentResponseByContinent {
	name: string;
	countries: CountryAssessments[];
}

export const genericApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAppParameters: builder.query<AppParameter[], void>({
			query: () => "parameters/",
		}),
		getIsConfigCorrect: builder.query<boolean, IsConfigCorrectPayload>({
			query: ({ climate, moisture, soilType }) => `ipcc/soil-organic-carbons/?climate=${climate}&moisture=${moisture}&soil_type=${soilType}`,
			transformResponse: (response: SoilOrganicCarbonsResponse[]) => response.length > 0 && response.some((item) => item.value !== null),
		}),
		getCropYieldDefault: builder.query<number, CropYieldDefaultPayload>({
			query: ({ landUseType, region }) => `ipcc/crop-yield-stats/?land_use_type=${landUseType}&continent=${region}`,
			transformResponse: (response: CropYieldStatsResponse) => response.average,
		}),
		getCultivationDaysDefault: builder.query<number | null, CultivationDaysDefaultPayload>({
			query: ({ region }) => `ipcc/rice-default-emission-factors/?continent=${region}`,
			transformResponse: (response: CultivationDaysDefaultResponse[]) => response.length > 0 ? response[0].cultivation_period : null,
		}),
		getCountryEmissionFactors: builder.query<CountryEmissionFactorsResponse[], number>({
			query: (countryId) => `ipcc/electricity-emissions/?country=${countryId}`,
		}),
		getHIHAssessments: builder.query<HIHAssessmentResponseByContinent[], void>({
			query: () => "hih-assessments/?grouped=true",
		}),
	}),
});

export const { useGetAppParametersQuery, useGetIsConfigCorrectQuery, useGetCultivationDaysDefaultQuery, useGetCropYieldDefaultQuery, useLazyGetCountryEmissionFactorsQuery, useGetHIHAssessmentsQuery } = genericApiSlice